function init() {

  /***************
   *  //importing slick and fancybox
   *********************/
  require('slick-carousel');
  require('@fancyapps/fancybox');

  /***************
   *  //Variables
   *********************/
  var $gallery = $('.slider');
  var $articleSlider = $('.article__slider');
  var $fancy = $('data-fancybox');
  var $galleryHeading = $('.overlay__heading');
  var $newsWrap = $('.news__wrap');
  var $vidsSlider = $('.videos__slider');
  var $headerBurger = $('.header__burger');
  var $bar = $headerBurger.find('.bar');

  /*===============================================
   *  Init fancybox
   =================================================*/
  if ($fancy.length > 0) {
    $fancy.fancybox({
      buttons: [
        "zoom",
        "slideShow",
        "fullScreen",
        "close"
      ],
      hash: false,
      fitToView: false,
    });
  }


  // video section fancy box
  $('.fancybox').fancybox({
    'type': 'iframe',
    'width': 800, //or whatever you want
    'height': 600
  });


  /*===============================================
   *  INTRO SECTION
   =================================================*/

  /***************
   *  //Main
   *********************/
  $gallery.slick({
    autoplay: true,
    dots: true,
    appendDots: $('.slider__controls'),
    dotsClass: 'slider__controls__dots',
    arrows: false,
    slidesToShow: 1,
    draggable: false,
    mobileFirst: true,
    // this function is for customizing slider buttons
    customPaging: function (slider, i) {
      var slideNumber = (i + 1),
        totalSlides = slider.slideCount;

      return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">' + slideNumber + '/' + totalSlides + '</span></a>';
    }
  });
  // change the overlay header based on the changing slide
  $gallery.on('init reinit afterChange', function (event, slick, currentSlide, nextSlide) {
    var $heading = $('.slick-current').find('.slider__heading').get(0).innerText;
    $galleryHeading.text($heading);
  })

  /*===============================================
   *  NEWS SECTION
   =================================================*/
  $newsWrap.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    infinite: true,
    prevArrow: $('.news__arrowup'),
    nextArrow: $('.news__arrowdown')
  });

  /*===============================================
   *  VIDEOS SECTION
   =================================================*/
  $vidsSlider.slick({
    rtl: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplay: false,
    prevArrow: $('.videos__btn--left'),
    nextArrow: $('.videos__btn--right'),
    centerMode: true,
    responsive: [{
        breakpoint: 1150,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });

  // same height for video cards ---no matter what!---
  var maxHeight = 0;

  $(".card_vid").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

  $(".card_vid").height(maxHeight);

  /*===============================================
   *  ARTICLE SECTION
  =================================================*/

  function makeItSlide() {
    $articleSlider.not('.slick-initialized').slick({
      rtl: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      centerMode: true,
      responsive: [{
          breakpoint: 9999,
          settings: "unslick"
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 321,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          }
        },
      ]
    });
  }


  if (windowWidth <= SCREEN.SM) {
    makeItSlide();
  }

  $(window).resize(function () {
    makeItSlide();
  });

  /*===============================================
   *  COMMENTS SECTION
   =================================================*/

  $('.comments__slider').slick({
    autoplay: true,
    appendDots: $('.comments__controls'),
    dotsClass: 'comment-dots',
    dots: true,
    arrows: false,
    slidesToShow: 1,
    draggable: false,
    mobileFirst: true,
    // this function is for customizing slider buttons
    customPaging: function (slider, i) {
      var slideNumber = (i + 1),
        totalSlides = slider.slideCount;
      return '<a class="cmdot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="str">' + slideNumber + '/' + totalSlides + '</span></a>';
    }
  });


  /*===============================================
   *  HEROES SECTION
   =================================================*/
  $('.heroes__slider').slick({
    rtl: true,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    draggable: true,
    prevArrow: $('.heroes__arrow--left'),
    nextArrow: $('.heroes__arrow--right'),
    responsive: [{
        breakpoint: 1051,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * 
   * DISABLED goto--active btns
   * * * * * * * * * * * * * * * * * * * * * * * * * * * */
  $('.goto--active').on('click', function (e) {
    e.preventDefault();
    return false;
  });


  /* * * * * * * * * * * * * * * * * * * * * * * * * * * 
   * CALCULATING THE TOODE BADANI!!!
   * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  var allnumber = /^\d+$/;
  var $bmiErr = $('.article__bmierr');

  /*============
   * functions
   *=========*/

  // function that shows the error msg if there is an error
  function showErrMsg(el, msg) {
    $bmiErr.text(msg).fadeIn();

    el.css({
      "box-shadow": "0 0 2px #C9092E",
      "border": "2px solid red"
    });
    setTimeout(function () {
      $bmiErr.fadeOut();
      el.css({
        "box-shadow": "none",
        "border": "2px solid #2f3d5c"
      });
    }, 5000);
  }

  // function to detect if an entry is not FARSI 
  function isArabic(strInput) {
    var arregex = /[\u0600-\u06FF]/;
    if (arregex.test(strInput)) {
      return true;
    } else {
      return false;
    }
  }


  // function to turn farsi numbers to english numbers
  function persianToEnglish(value) {
    var newValue = "";
    for (var i = 0; i < value.length; i++) {
      var ch = value.charCodeAt(i);
      if (ch >= 1776 && ch <= 1785) // For Persian digits.
      {
        var newChar = ch - 1728;
        newValue = newValue + String.fromCharCode(newChar);
      } else if (ch >= 1632 && ch <= 1641) // For Arabic & Unix digits.
      {
        var newChar = ch - 1584;
        newValue = newValue + String.fromCharCode(newChar);
      } else {
        newValue = newValue + String.fromCharCode(ch);
      }
    }

    return newValue;
  }



  $('#calculateToode').on('click', function (e) {
    e.preventDefault();
    // get height
    var height = $('#height').val();
    // get weight
    var weight = $('#weight').val();


    // if height input is empty
    if (height.length <= 0) {
      showErrMsg($('#height'), 'لطفا قد خود را وارد کنید');
      return false;
    }

    // check to see if its arabic then transform it ino english    
    if (isArabic(height)) {
      height = persianToEnglish(height);
    }

    if (!allnumber.test(height)) {
      showErrMsg($('#height'), 'لطفا قد خود را به عدد وارد کنید');
      return false;
    }

    


    // if weight input is empty
    if (weight.length <= 0) {
      showErrMsg($('#weight'), 'لطفا وزن خود را وارد کنید');
      return false;
    }

    // check to see if its arabic then transform it ino english    
    if (isArabic(weight)) {
      weight = persianToEnglish(weight);
    }

    if (!allnumber.test(weight)) {
      showErrMsg($('#weight'), 'لطفا وزن خود را به عدد وارد کنید');
      return false;
    }    


    // convert height from cm to m
    height = height / 100;


    // console.log('height', height);
    // console.log('weight', weight);


    // calculate final result

    var toodebadani = weight / (height * height);
    toodebadani = (Math.round(toodebadani * 2) / 2).toFixed(1);
    // console.log('toodebadani', toodebadani);
    $('.article__bminum').text(toodebadani);
    $('.article__bmi-result').show();
  });

}


$(function () {
  init();
});